document.addEventListener('DOMContentLoaded', function () {

  // OPEN submenu
  document.querySelectorAll('.mega_menu_drawer').forEach(item => {
    item.addEventListener('click', function (event) {

      event.preventDefault();

      const submenu = this.querySelector('.menu-drawer__menu--grandchildlist');
      if (!submenu) return;

      submenu.classList.add('active'); // show
    });
  });

  // BACK / CLOSE button
  document.addEventListener('click', function (e) {
    const backBtn = e.target.closest('.back_or_forward_btn');
    if (backBtn) {
      document.querySelectorAll('.menu-drawer__menu--grandchildlist').forEach(menu => {
        menu.classList.remove('active'); // hide
      });
    }
  });

});
